export default __webpack_public_path__ + "static/media/refresh_captcha_image.eff6736f.svg";